import { render, staticRenderFns } from "./GymBlockList.vue?vue&type=template&id=62311b22&"
import script from "./GymBlockList.vue?vue&type=script&lang=js&"
export * from "./GymBlockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports